import React, { useState, useEffect, useMemo, useRef } from 'react';
import Vn from '../vn/vn';
import BlackScreen from '../blackScreen/blackScreen';
import Test from '../test/test';
import plot from'../../services/plot'
import {IsLSWork} from '../app/app'

function Play({step, state, setStep, goMenu, achievementsSave, gallerySC, hzAdjuster}) {
  const [isLS, setIsLS] = useState(IsLSWork());
  const [plotLine, setPlotLine] = useState( isLS ? localStorage.getItem('plotLineSC') === null? 0 : parseInt(localStorage.getItem('plotLineSC')) : 0);

  function goNext(i){
    if(i == undefined){
    if(isLS){
    localStorage.setItem('stepSC1', step+1);
  }
    setStep(prev => prev+1);
  }else{
    if(isLS){
    localStorage.setItem('stepSC1', step+i);
  }
    setStep(prev => prev+i);
  }
  }


  if(plot[step]["novel"]){
    return(
    <Vn goMenu={goMenu} state={state} plot={plot[step]["script"]} isLS={isLS} background={plot[step]["background"]} step={step} goNext={goNext} startCoordinates={plot[step]["startCoordinates"]} achievementsSave={achievementsSave} gallerySC={gallerySC} hzAdjuster={hzAdjuster} key={step}/>
    );
  }
  if(plot[step]["test"]){
    return(
    <Test goMenu={goMenu} questionsArr={plot[step]["questions"]} isLS={isLS} goNext={goNext} state={state} step={step} achievementsSave={achievementsSave} hzAdjuster={hzAdjuster} key={step}/>
    );
  }
  if(plot[step]["afterTest"]){
    let result;
    if(state.current[step-1]["testResult"] == 0){
      result = "resultAA";
    }else if(state.current[step-1]["testResult"] == 1){
      result = "resultA";
    }else if(state.current[step-1]["testResult"] == 2 ){
      result = "resultB";
    }else if(state.current[step-1]["testResult"] == 3){
      result = "resultC";
    }else if(state.current[step-1]["testResult"] >= 4){
      result = "resultD";
    }
    if(state.current[step-1]["specialQuestion"]){
      if((state.current[step-1]["specialQuestion"] == "a" || state.current[step-1]["specialQuestion"] == "b") && result !== "resultAA"){
        plot[step][result] = plot[step][result].concat(plot[step]["answeredSpecialQuestion"]);
      }else if((state.current[step-1]["specialQuestion"] == "a" || state.current[step-1]["specialQuestion"] == "b") && result == "resultAA"){
        plot[step][result] = plot[step][result].concat(plot[step]["answeredSpecialQuestionAroused"]);
      }
    }
    if(result !== "resultAA"){
      plot[step][result] = plot[step][result].concat(plot[step]["ending"]);
    }else if(result == "resultAA"){
      plot[step][result] = plot[step][result].concat(plot[step]["endingAroused"]);
    }

    return(
    <Vn goMenu={goMenu} state={state} plot={plot[step][result]} isLS={isLS} background={plot[step]["background"]} step={step} goNext={goNext} startCoordinates={plot[step]["startCoordinates"]} achievementsSave={achievementsSave} gallerySC={gallerySC} hzAdjuster={hzAdjuster} key={step}/>
    );
  }
  if(step !== undefined && plot[step]["blackScreen"]){
    return (
      <BlackScreen goMenu={goMenu} txt={plot[step]["txt"]} end={plot[step]["end"]} trailer={plot[step]["trailer"]} goNext={goNext} step={step} state={state} setStep={setStep} hzAdjuster={hzAdjuster}/>
  );
  }

}

export default Play;
